import React, { useState, useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../App';
import Sidebar from '../components/Sidebar';
import './FormStyles.css';

const API = 'https://cctvapi.shopkwality.in/api';

const EditCategory = () => {
  const { id } = useParams();
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchCategory();
  }, [id]);

  const fetchCategory = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/categories/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 10000
      });
      
      console.log('Category data:', res.data);
      setName(res.data.name || '');
      setDescription(res.data.description || '');
    } catch (err) {
      console.error('Fetch category error:', err);
      
      let errorMessage = 'Unable to fetch category';
      if (err.response?.status === 404) {
        errorMessage = 'Category not found';
      } else if (err.response?.status === 401) {
        errorMessage = 'Session expired. Please login again.';
      }
      
      alert(errorMessage);
      navigate('/categories');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      alert('Category name cannot be empty');
      return;
    }

    setSaving(true);
    try {
      const response = await axios.patch(
        `${API}/categories/${id}`,
        { 
          name: name.trim(),
          description: description.trim() || undefined
        },
        { 
          headers: { Authorization: `Bearer ${token}` },
          timeout: 10000
        }
      );
      
      console.log('Update response:', response.data);
      alert('Category updated successfully');
      navigate('/categories');
    } catch (err) {
      console.error('Update category error:', err);
      
      let errorMessage = 'Failed to update category';
      
      if (err.response) {
        errorMessage = err.response.data?.message || errorMessage;
        
        if (err.response.status === 403) {
          errorMessage = 'Access denied. Only staff can update categories.';
        } else if (err.response.status === 401) {
          errorMessage = 'Session expired. Please login again.';
        }
      } else if (err.request) {
        errorMessage = 'Cannot connect to server. Check your network.';
      }
      
      alert(errorMessage);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-layout">
        <Sidebar />
        <div className="dashboard-main">
          <div className="loading-container">
            <div className="spinner large"></div>
            <p>Loading category...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <div className="form-container">
          <div className="form-header">
            <h1>Edit Category</h1>
          </div>

          <form onSubmit={handleSubmit} className="modern-form">
            <div className="form-section">
              <div className="form-group">
                <label className="form-label required">Category Name</label>
                <input
                  type="text"
                  required
                  className="form-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter category name"
                  disabled={saving}
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label className="form-label">Description</label>
                <textarea
                  className="form-textarea"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter category description (optional)"
                  rows="4"
                  disabled={saving}
                />
              </div>
            </div>

            <div className="form-actions">
              <button 
                type="submit" 
                disabled={saving} 
                className="btn btn-primary"
              >
                {saving ? (
                  <>
                    <span className="spinner"></span>
                    Updating...
                  </>
                ) : (
                  'Update Category'
                )}
              </button>
              <button 
                type="button" 
                onClick={() => navigate('/categories')} 
                className="btn btn-secondary"
                disabled={saving}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditCategory;
